import { render } from "./DefaultMaestro.vue?vue&type=template&id=a7d81e52"
import script from "./DefaultMaestro.vue?vue&type=script&lang=js"
export * from "./DefaultMaestro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__